import React from 'react';
import { Icon } from 'semantic-ui-react';
import { StepsWrapper } from 'react-lib/dist/components-es';
import { type } from 'os';

type Props = {
  currentStep: number;
  setCurrentStep: any;
};

const ActivityDetailsCreateModeSteps = ({ currentStep, setCurrentStep }: Props) => {
  const steps = [
    {
      title: 'activity.details.page.activity.details.container.steps.1.title',
      iconComponent: <Icon className="wrench" />,
      description: 'activity.details.page.activity.details.container.steps.1.description',
    },
    {
      title: 'activity.details.page.activity.details.container.steps.2.title',
      iconComponent: <Icon className="file alternate" />,
      description: 'activity.details.page.activity.details.container.steps.2.description',
    },
    {
      title: 'activity.details.page.activity.details.container.steps.3.title',
      iconComponent: <Icon className="file alternate" />,
      description: 'activity.details.page.activity.details.container.steps.3.description',
    },
    {
      title: 'activity.details.page.activity.details.container.steps.4.title',
      iconComponent: <Icon className="file alternate" />,
      description: 'activity.details.page.activity.details.container.steps.4.description',
    },
  ];

  return <StepsWrapper steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />;
};

export default React.memo(ActivityDetailsCreateModeSteps);
